export const spanishResourceMessages = {
  resources: {
    companies: {
      name: "Empresa |||| Empresas",
      forcedCaseName: "Empresa",
      fields: {
        name: "Nombre de la empresa",
        website: "Sitio web",
        linkedin_url: "URL de LinkedIn",
        phone_number: "Teléfono",
        created_at: "Fecha de creación",
        nb_contacts: "Cantidad de contactos",
        revenue: "Ingresos",
        sector: "Sector",
        size: "Tamaño",
        tax_identifier: "Identificador tributario",
        address: "Dirección",
        city: "Ciudad",
        zipcode: "Código postal",
        state_abbr: "Región/Estado",
        country: "País",
        description: "Descripción",
        context_links: "Enlaces de contexto",
        sales_id: "Responsable de la cuenta",
      },
      empty: {
        description: "La lista de empresas está vacía.",
        title: "No se encontraron empresas",
      },
      field_categories: {
        contact: "Contacto",
        additional_info: "Información adicional",
        address: "Dirección",
        context: "Contexto",
      },
      action: {
        create: "Crear empresa",
        edit: "Editar empresa",
        new: "Nueva empresa",
        show: "Ver empresa",
      },
      added_on: "Agregada el %{date}",
      followed_by: "Gestionada por %{name}",
      followed_by_you: "Gestionada por ti",
      no_contacts: "Sin contactos",
      nb_contacts: "%{smart_count} contacto |||| %{smart_count} contactos",
      nb_deals: "%{smart_count} oportunidad |||| %{smart_count} oportunidades",
      sizes: {
        one_employee: "1 empleado",
        two_to_nine_employees: "2-9 empleados",
        ten_to_forty_nine_employees: "10-49 empleados",
        fifty_to_two_hundred_forty_nine_employees: "50-249 empleados",
        two_hundred_fifty_or_more_employees: "250 empleados o más",
      },
      autocomplete: {
        create_error: "Ocurrió un error al crear la empresa",
        create_item: "Crear %{item}",
        create_label: "Comienza a escribir para crear una empresa nueva",
      },
      filters: { only_mine: "Solo las empresas que gestiono" },
    },
    contacts: {
      name: "Contacto |||| Contactos",
      forcedCaseName: "Contacto",
      field_categories: {
        background_info: "Antecedentes",
        identity: "Identidad",
        misc: "Información adicional",
        personal_info: "Información personal",
        position: "Cargo",
      },
      fields: {
        first_name: "Nombre",
        last_name: "Apellido",
        last_seen: "Última actividad",
        title: "Cargo",
        department: "Departamento",
        decision_role: "Rol en la decisión",
        company_id: "Empresa",
        email_jsonb: "Correos electrónicos",
        email: "Correo electrónico",
        phone_jsonb: "Teléfonos",
        phone_number: "Teléfono",
        linkedin_url: "URL de LinkedIn",
        background: "Antecedentes (biografía, cómo se conocieron, etc.)",
        has_newsletter: "Recibe boletín",
        sales_id: "Responsable de la cuenta",
        next_follow_up: "Próximo seguimiento",
      },
      action: {
        add: "Agregar contacto",
        add_first: "Agregar tu primer contacto",
        create: "Crear contacto",
        edit: "Editar contacto",
        export_vcard: "Exportar a vCard",
        new: "Nuevo contacto",
        show: "Ver contacto",
      },
      background: {
        last_activity_on: "Última actividad el %{date}",
        added_on: "Agregado el %{date}",
        followed_by: "Gestionado por %{name}",
        followed_by_you: "Gestionado por ti",
        status_none: "Ninguno",
      },
      position_at: "%{title} en",
      position_at_company: "%{title} en %{company}",
      empty: {
        description: "La lista de contactos está vacía.",
        title: "No se encontraron contactos",
      },
      import: {
        title: "Importar contactos",
        button: "Importar CSV",
        complete:
          "Importación terminada. Se importaron %{importCount} contactos, con %{errorCount} errores",
        progress:
          "Se importaron %{importCount} de %{rowCount} contactos, con %{errorCount} errores.",
        error:
          "No se pudo importar el archivo. Comprueba que sea un CSV válido.",
        imported: "Importados",
        remaining_time: "Tiempo restante estimado:",
        running: "La importación está en curso. No cierres esta pestaña.",
        sample_download: "Descargar CSV de ejemplo",
        sample_hint: "Puedes usar este archivo CSV como plantilla",
        stop: "Detener importación",
        csv_file: "Archivo CSV",
        contacts_label: "contacto |||| contactos",
      },
      inputs: {
        genders: { male: "Él", female: "Ella", nonbinary: "Elle" },
        personal_info_types: {
          work: "Trabajo",
          home: "Casa",
          other: "Otro",
        },
      },
      list: { error_loading: "Error al cargar los contactos" },
      bulk_tag: {
        action: "Etiquetar",
        back: "Volver a las etiquetas",
        create_description:
          "Crea una etiqueta y aplícala a los contactos seleccionados.",
        description:
          "Elige una etiqueta existente o crea una para los contactos seleccionados.",
        empty:
          "Todavía no hay etiquetas. Crea una para etiquetar los contactos seleccionados.",
        error: "No se pudo agregar la etiqueta a los contactos",
        noop: "Los contactos seleccionados ya tienen esta etiqueta",
        success:
          "Etiqueta agregada a %{smart_count} contacto |||| Etiqueta agregada a %{smart_count} contactos",
        title: "Agregar etiqueta a contactos",
      },
      merge: {
        action: "Combinar con otro contacto",
        confirm: "Combinar contactos",
        current_contact: "Contacto actual (se eliminará)",
        description: "Combina este contacto con otro.",
        error: "No se pudieron combinar los contactos",
        merging: "Combinando...",
        no_additional_data: "No hay datos adicionales para combinar",
        select_target: "Selecciona el contacto con el que deseas combinarlo",
        success: "Contactos combinados correctamente",
        target_contact: "Contacto de destino (se conservará)",
        title: "Combinar contacto",
        warning_description:
          "Todos los datos se transferirán al segundo contacto. Esta acción no se puede deshacer.",
        warning_title: "Advertencia: operación irreversible",
        what_will_be_merged: "Datos que se combinarán:",
      },
      filters: {
        before_last_month: "Antes del mes pasado",
        before_this_month: "Antes de este mes",
        before_this_week: "Antes de esta semana",
        managed_by_me: "Gestionados por mí",
        search: "Buscar nombre, empresa...",
        this_week: "Esta semana",
        today: "Hoy",
        tags: "Etiquetas",
        tasks: "Tareas",
      },
      hot: {
        empty_change_status:
          "Cambia el estado de un contacto agregando una nota y seleccionando «Mostrar opciones».",
        empty_hint: "Los contactos con estado «caliente» aparecerán aquí.",
        title: "Contactos prioritarios",
      },
    },
    deals: {
      name: "Oportunidad |||| Oportunidades",
      fields: {
        name: "Nombre",
        description: "Descripción",
        company_id: "Empresa",
        primary_contact_id: "Contacto principal",
        contact_ids: "Contactos",
        category: "Categoría",
        amount: "Presupuesto",
        currency: "Moneda",
        probability: "Probabilidad",
        expected_closing_date: "Fecha estimada de cierre",
        stage: "Etapa",
        next_step: "Próximo paso",
        loss_reason: "Motivo de pérdida",
      },
      action: {
        back_to_deal: "Volver a la oportunidad",
        create: "Crear oportunidad",
        new: "Nueva oportunidad",
      },
      field_categories: { misc: "Información adicional" },
      archived: {
        action: "Archivar",
        error: "Error: la oportunidad no se archivó",
        list_title: "Oportunidades archivadas",
        success: "Oportunidad archivada",
        title: "Oportunidad archivada",
        view: "Ver oportunidades archivadas",
      },
      inputs: { linked_to: "Vinculada a" },
      unarchived: {
        action: "Devolver al tablero",
        error: "Error: la oportunidad no se restauró",
        success: "Oportunidad restaurada",
      },
      updated: "Oportunidad actualizada",
      empty: {
        before_create: "antes de crear una oportunidad.",
        description: "La lista de oportunidades está vacía.",
        title: "No se encontraron oportunidades",
      },
      invalid_date: "Fecha no válida",
    },
    notes: {
      name: "Nota |||| Notas",
      forcedCaseName: "Nota",
      fields: {
        status: "Estado",
        date: "Fecha",
        attachments: "Archivos adjuntos",
        contact_id: "Contacto",
        deal_id: "Oportunidad",
      },
      action: {
        add: "Agregar nota",
        add_first: "Agregar tu primera nota",
        delete: "Eliminar nota",
        edit: "Editar nota",
        update: "Actualizar nota",
        add_this: "Agregar esta nota",
      },
      sheet: {
        create: "Crear nota",
        create_for: "Crear nota para %{name}",
        edit: "Editar nota",
        edit_for: "Editar nota para %{name}",
      },
      deleted: "Nota eliminada",
      empty: "Aún no hay notas",
      author_added: "%{name} agregó una nota",
      you_added: "Agregaste una nota",
      me: "Yo",
      list: { error_loading: "Error al cargar las notas" },
      note_for_contact: "Nota para %{name}",
      stepper: {
        hint: "Ve a la página de un contacto y agrega una nota",
      },
      added: "Nota agregada",
      inputs: {
        add_note: "Agregar una nota",
        options_hint: "(adjunta archivos o cambia los detalles)",
        show_options: "Mostrar opciones",
      },
      actions: { attach_document: "Adjuntar documento" },
      validation: {
        note_or_attachment_required:
          "Se requiere una nota o un archivo adjunto",
      },
    },
    sales: {
      name: "Usuario |||| Usuarios",
      fields: {
        first_name: "Nombre",
        last_name: "Apellido",
        email: "Correo electrónico",
        administrator: "Administrador",
        disabled: "Desactivado",
        pending: "Pendiente",
      },
      create: {
        error: "Ocurrió un error al crear el usuario.",
        success:
          "Usuario creado. Pronto recibirá un correo para definir su contraseña.",
        title: "Crear usuario",
      },
      edit: {
        error: "Ocurrió un error. Inténtalo nuevamente.",
        record_not_found: "No se encontró el registro",
        success: "Usuario actualizado correctamente",
        title: "Editar %{name}",
      },
      action: { new: "Nuevo usuario" },
    },
    tasks: {
      name: "Tarea |||| Tareas",
      forcedCaseName: "Tarea",
      fields: {
        text: "Descripción",
        due_date: "Fecha límite",
        type: "Tipo",
        contact_id: "Contacto",
        due_short: "vence",
      },
      action: {
        add: "Agregar tarea",
        create: "Crear tarea",
        edit: "Editar tarea",
      },
      actions: {
        postpone_next_week: "Posponer hasta la próxima semana",
        postpone_tomorrow: "Posponer hasta mañana",
        title: "Acciones de la tarea",
      },
      added: "Tarea agregada",
      deleted: "Tarea eliminada correctamente",
      dialog: {
        create: "Crear tarea",
        create_for: "Crear tarea para %{name}",
      },
      sheet: {
        edit: "Editar tarea",
        edit_for: "Editar tarea para %{name}",
      },
      empty: "Aún no hay tareas",
      empty_list_hint: "Las tareas agregadas a tus contactos aparecerán aquí.",
      filters: {
        later: "Más adelante",
        overdue: "Vencidas",
        this_week: "Esta semana",
        today: "Hoy",
        tomorrow: "Mañana",
        with_pending: "Con tareas pendientes",
      },
      regarding_contact: "(Sobre: %{name})",
      updated: "Tarea actualizada",
    },
    tags: {
      name: "Etiqueta |||| Etiquetas",
      action: { add: "Agregar etiqueta", create: "Crear etiqueta" },
      dialog: {
        color: "Color",
        create_title: "Crear etiqueta",
        edit_title: "Editar etiqueta",
        name_label: "Nombre de la etiqueta",
        name_placeholder: "Escribe el nombre",
      },
    },
    meetings: {
      name: "Reunión |||| Reuniones",
      fields: {
        title: "Título",
        meeting_type: "Tipo de reunión",
        company_id: "Empresa",
        deal_id: "Oportunidad",
        contact_ids: "Participantes",
        sales_id: "Responsable",
        starts_at: "Inicio",
        ends_at: "Término",
        location: "Ubicación",
        meeting_url: "Enlace de la reunión",
        summary: "Resumen",
        key_points: "Puntos clave",
        decisions: "Decisiones",
        next_steps: "Próximos pasos",
        outcome: "Resultado",
      },
    },
    email_messages: {
      name: "Correo |||| Correos",
      fields: {
        status: "Estado",
        sender_email: "Remitente",
        subject: "Asunto",
        snippet: "Contenido",
        company_id: "Empresa",
        contact_id: "Contacto",
        deal_id: "Oportunidad",
        received_at: "Fecha de recepción",
        provider: "Proveedor",
      },
    },
  },
} as const;
